export default __webpack_public_path__ + "static/media/icon-close.fb058f42.svg";